export const BUS_SLOTS = {
  Prishtinë: {
    pickupDropoff: 'SPEEEX HQ Prishtinë',
    departures: ['13:00', '14:30', '16:00'],
    returns: ['22:00', '23:00', '00:00']
  },
  Prizren: {
    pickupDropoff: 'SPEEEX Prizren',
    departures: ['12:00', '14:00'],
    returns: ['22:00', '00:00']
  },
  Vushtrri: {
    pickupDropoff: 'SPEEEX Vushtrri',
    departures: ['12:30', '14:00', '15:00'],
    returns: ['22:00', '23:00', '00:00']
  },
  Ferizaj: {
    pickupDropoff: 'SPEEEX Ferizaj',
    departures: ['12:30', '14:00', '15:00'],
    returns: ['22:00', '23:00', '00:00']
  }
}

export const BUS_CITIES = Object.keys(BUS_SLOTS)

export const EVENT_PERIOD_START_UTC = '2026-06-17 00:00:00'
export const EVENT_PERIOD_END_UTC = '2026-06-18 23:59:59'
